// R10e36.68-F826: Brand logo component with graceful fallback
// Loads logo file from /branding/ path. If file missing, renders styled text wordmark.

import React, { useState } from 'react';
import { Building2 } from 'lucide-react';
import { BRAND } from '../brand';

export default function BrandLogo({ variant = 'public', collectorId, logoUrl, className = 'h-10' }) {
  const [imageOk, setImageOk] = useState(true);

  // PC41a: The per-collector logo path was constructed speculatively —
  // /branding/collector-{id}.svg — but nothing writes there. Uploaded
  // collector logos live behind /collector/branding/logo (GCS), not the
  // static folder. So collector-variant requests always 404'd before the
  // graceful fallback took over. Only issue the network request when the
  // caller explicitly passes a `logoUrl` prop; otherwise render the icon
  // fallback directly (no network, no console noise).
  let logoPath = null;
  if (logoUrl) {
    logoPath = logoUrl;
  } else if (variant === 'public') {
    logoPath = '/branding/paezproptax-logo.svg';
  } else if (variant === 'collector' || variant === 'platform') {
    // PC135d: Collector header now shows the RECT platform logo on the
    // left (unless a per-collector logoUrl was passed). Same file for
    // both 'collector' and 'platform' variants. If the file is missing,
    // the onError fallback below renders the Building2 icon.
    logoPath = '/branding/RECT_Logo_Horizontal_1600px.png';
  } else {
    logoPath = '/branding/logo.svg';
  }

  if (!logoPath || !imageOk) {
    // Fallback: styled text wordmark or icon
    if (variant === 'public') {
      return (
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-lg">
            PPT
          </div>
        </div>
      );
    }
    return (
      <Building2 className={`${className} text-blue-600`} />
    );
  }

  return (
    <img
      src={logoPath}
      alt={variant === 'public' ? BRAND.publicPortalName : 'Logo'}
      className={className}
      onError={() => setImageOk(false)}
    />
  );
}
